import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Navbar from "../containers/Home/Navbar";
import IntroForm from "../containers/Home/IntroForm";

const Home = () => {
  const isLoggedin = useSelector((state) => state.user.isLoggedin);
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="landing-home content px-0 px-md-3">
        <div className="container-fluid">
          <div className="row">
            <div className="wrapper pt-1 pt-md-4">
              <h2 className="home-title">
                <span className="pa-color-highlight">{t("home.intro")}</span>
              </h2>
              <IntroForm />
            </div>
          </div>
          <div className="row">
            <div className="col mt-5 mt-sm-1 area-light-text">
              <div className="limiter-box text-center">
                <h3>{t("home.footerHeading")}</h3>
                <p>{t("home.footerText1")}</p>
                <p>{t("home.footerText2")}</p>
                {!isLoggedin && (
                  <>
                    <p>
                      <Link to="/signup" className="btn btn-lg btn-light">
                        {t("home.signupButton")}
                      </Link>
                    </p>
                    <p>
                      <Link to="/login">
                        <i className="bi bi-arrow-right-square" />{" "}
                        {t("home.loginText")}
                      </Link>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
